import { createRoot } from 'react-dom/client'

import BigNumber from 'bignumber.js'
import 'translations/i18n'

import Themes from 'containers/Themes'

import 'styles/app.scss'
import '@mantine/dates/styles.css'

import App from './app'

const fmt = {
  decimalSeparator: '.',
  groupSeparator: ',',
  groupSize: 3,
}

BigNumber.config({ FORMAT: fmt })

window.addEventListener('vite:preloadError', () => {
  window.location.reload()
})

const root = createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <Themes>
    <App />
  </Themes>,
)
